"use strict";

var isUndefined = require('lodash/isUndefined');

var copies = require('./copies');

var fileText = require('./fileText');

var qtyText = require('./qtyText');

var testPrintsQtyText = require('./testPrintsQtyText');

var sizeText = require('./sizeText');

var orientationText = require('./orientationText');

var queueText = require('./queueText');

var paperText = require('./paperText');

var cutCodeText = require('./cutCodeText');

var noteText = require('./noteText');

var envelopeFileText = require('./envelopeFileText');

var envelopeNoteText = require('./envelopeNoteText');

var envelopeQtyText = require('./envelopeQtyText');

var envelopeSizeText = require('./envelopeSizeText');

var envelopeColorText = require('./envelopeColorText');

var ribbonColor = require('./ribbonColor');

var numSpools = require('./numSpools');

var waxSealQuantity = require('./waxSealQuantity');

var vellumJacketQuantity = require('./vellumJacketQuantity');

var glueDotsQuantity = require('./glueDotsQuantity');

var waxSealStyle = require('./waxSealStyle');

var coloredInkUpcharge = require('./coloredInkUpcharge');

var printingCost = require('./printingCost');

var shrinkWrappingCost = require('./shrinkWrappingCost');

var pricingLabelText = require('./pricingLabelText');

var composables = {
  copies: copies,
  fileText: fileText,
  qtyText: qtyText,
  testPrintsQtyText: testPrintsQtyText,
  sizeText: sizeText,
  orientationText: orientationText,
  queueText: queueText,
  paperText: paperText,
  cutCodeText: cutCodeText,
  noteText: noteText,
  envelopeFileText: envelopeFileText,
  envelopeNoteText: envelopeNoteText,
  envelopeQtyText: envelopeQtyText,
  envelopeSizeText: envelopeSizeText,
  ribbonColor: ribbonColor,
  numSpools: numSpools,
  waxSealQuantity: waxSealQuantity,
  vellumJacketQuantity: vellumJacketQuantity,
  glueDotsQuantity: glueDotsQuantity,
  waxSealStyle: waxSealStyle,
  printingCost: printingCost,
  shrinkWrappingCost: shrinkWrappingCost,
  pricingLabelText: pricingLabelText,
  envelopeColorText: envelopeColorText,
  coloredInkUpcharge: coloredInkUpcharge
};

function getComposables(folder, members) {
  if (!members) {
    return [];
  }

  if (!Array.isArray(members)) {
    throw new Error("".concat(folder, " > ").concat(members, " members was not an array"));
  }

  return members.map(function (member) {
    if (isUndefined(composables[folder][member])) {
      throw new Error("".concat(member, " was not found in ").concat(folder));
    }

    return composables[folder][member];
  });
}

module.exports = getComposables;